import {texture} from "p3";

export default class CoinAnimation extends PIXI.Container {
    constructor(coinAmount, tweenHolder, onUpdate, tweenTo = {x:0, y:-200}, duration = 0.4) {
        super();

        this.coinAmount = coinAmount;
        this.tweenHolder = tweenHolder;
        this.onUpdate = onUpdate;
        
        const max = Math.min(25, this.coinAmount);

        for (let i = 0; i < max; i++) {
            let coin = new PIXI.Sprite(texture('prop_gold_coin_01'));
            coin.anchor.set(0.5);
            coin.visible = false;
            this.addChild(coin);
            this.tweenHolder.addTween(
                gsap.to(coin, duration, {delay:i * 0.05, x:tweenTo.x, y:tweenTo.y, ease:Expo.easeOut, onStart:() => {
                    coin.visible = true;
                    P3.audio.playSound("sfx_pickup_coins");
                    if (this.onUpdate) {
                        this.onUpdate((i+1) / max);
                    }
                }, onComplete:() => {
                    coin.visible = false;
                }})
            );
        }
    }
}